export const data = [
 {
  id: 1,
  name: 'Americano',
  category: 'hot',
  type: 'coffee',
  Image:
  'https://images.pexels.com/photos/6207297/pexels-photo-6207297.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$'
 },
 {
  id: 2,
  name:'Iced Mocha',
  category: 'cold',
  type: 'coffee',
  Image:
  'https://images.pexels.com/photos/11100423/pexels-photo-11100423.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$'
 },
 {
  id: 3,
  name:'Matcha',
  category: 'hot',
  type: 'tea',
  Image:
  'https://images.pexels.com/photos/8634757/pexels-photo-8634757.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$$'
 },
 {
  id: 4,
  name:'Iced Matcha',
  category: 'iced',
  type: 'tea',
  Image:
  'https://images.pexels.com/photos/5946972/pexels-photo-5946972.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$'
 },
 {
  id: 5,
  name: 'Cappuccino',
  category: 'hot',
  type: 'coffee',
  Image:
  'https://images.pexels.com/photos/414555/pexels-photo-414555.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$'
 },
 {
  id: 6,
  name: 'Macchiato Latte',
  category: 'hot',
  type: 'coffee',
  Image:
  'https://images.pexels.com/photos/10187350/pexels-photo-10187350.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$'
 },
 {
  id: 7,
  name:'Chai Latte',
  category: 'hot',
  type: 'tea',
  Image:
  'https://images.pexels.com/photos/5946623/pexels-photo-5946623.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$'
 },
 {
  id: 8,
  name: 'Chai Tea Latte Boba ',
  category: 'iced',
  type: 'tea',
  Image:
  'https://images.pexels.com/photos/4071422/pexels-photo-4071422.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2',
  price: '$$$$'
 },
];


export const categories = [
 {
  id: 1,
  name: 'Grab-and-Go',
  image:
    'https://img.freepik.com/free-vector/illustration-coffee-go_53876-8119.jpg?w=1060&t=st=1664150822~exp=1664151422~hmac=2c8df4e8a9a1060ad530bdde9672b30116ccf039e8307916f1b4ff16a0c4df2c',
},
{
  id: 2,
  name: 'Restaurant',
  image:
    'https://img.freepik.com/premium-vector/american-breakfast-food_18591-49011.jpg?w=826',
},
{
  id: 3,
  name: 'Bakery',
  image:
    'https://img.freepik.com/premium-vector/chocolate-cupcake-white_81894-2365.jpg?w=740',
},
{
  id: 4,
  name: 'Craft Coffee',
  image:
    'https://img.freepik.com/free-vector/coffee-love-foam-with-beans-cartoon-icon-illustration_138676-2575.jpg?w=826&t=st=1664150546~exp=1664151146~hmac=53409d6c2f861455528bb87cee6d44345142d8acf9f2927bf0860d43219006d8',
},
{
  id: 5,
  name: 'Bookstore Coffee',
  image:
    'https://img.freepik.com/free-vector/stack-books-graphic-illustration_53876-8852.jpg?w=826&t=st=1664150770~exp=1664151370~hmac=3c71cf2fe1b9b639de0a07b52cfd27bd51979570ffeeeac621be39b504ecac30',
},
{
  id: 6,
  name: 'Pet Friendly',
  image:
    'https://img.freepik.com/free-vector/pet-logo-design-paw-vector-animal-shop-business_53876-136741.jpg?w=826&t=st=1664150308~exp=1664150908~hmac=f0a38819d6b679476fe335027c050429f94aa707ed5da42fa0bac7ff28cd881b',
},
{
  id: 7,
  name: 'Best Overall',
  image:
    'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/TopEats_Browse%20Home@3x.png',
},
{
  id: 8,
  name: 'Shipped Free',
  image:
    'https://duyt4h9nfnj50.cloudfront.net/new_search_home_eats_icon/Placeholder_Plates@3x.png',
},
 ]
